import { ClickAway } from '@/components/ui/click-away';
import IconFacebook from '@/icons/icon-facebook';
import IconLinkedin from '@/icons/icon-linkedin';
import IconEmail from '@/icons/icon-email';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from 'react-share';
import CopyIcon from '@/icons/copy';
import ShareIcon from '@/icons/share';
import { useState } from 'react';
import IconWhatsapp from '@/icons/icon-whatsapp';

function copyTextToClipboard(text: string) {
  if (!navigator.clipboard) {
    return;
  }

  return navigator.clipboard.writeText(text);
}

const ICON_SIZE = 32;

export interface SocialShareLinksProps {
  url: string;
  title: string;
  emailSubject: string;
  emailBody: string;
}

export function SocialShareLinks({
  url,
  title,
  emailSubject,
  emailBody,
}: SocialShareLinksProps) {
  const [visible, setVisible] = useState(false);

  const onShareClick = () => {
    setVisible((prev) => !prev);
  };

  const handleClickAway = () => {
    setVisible(false);
  };

  return (
    <ClickAway
      onClickAway={handleClickAway}
      className="relative"
      value={visible}
    >
      <div className="relative" title="Share">
        <div
          role="button"
          className="flex flex-row items-center text-sm text-primary-500 hover:bg-gray-100 px-2 py-1 rounded"
          onClick={onShareClick}
        >
          <ShareIcon className="text-primary-500 w-6 h-6" />
          &nbsp;Share
        </div>
        {visible && (
          <div className="absolute bg-primary-100 border border-primary-300 rounded top-full left-0 lg:top-0 lg:left-full shadow-2xl z-10">
            <div className="flex flex-col lg:flex-row justify-center transition duration-150">
              <WhatsappShareButton url={url} title={title}>
                <div
                  title="Share on Whatsapp"
                  className="p-2 hover:bg-primary-500 text-primary-500 hover:text-white"
                >
                  <IconWhatsapp width={ICON_SIZE} height={ICON_SIZE} />
                </div>
              </WhatsappShareButton>
              <FacebookShareButton url={url} quote={title}>
                <div
                  title="Share on Facebook"
                  className="p-2 hover:bg-primary-500 text-primary-500 hover:text-white"
                >
                  <IconFacebook width={ICON_SIZE} height={ICON_SIZE} />
                </div>
              </FacebookShareButton>
              <EmailShareButton
                url={url}
                subject={emailSubject}
                body={emailBody}
              >
                <div
                  title="Share by Email"
                  className="p-2 hover:bg-primary-500 text-primary-500 hover:text-white"
                >
                  <IconEmail width={ICON_SIZE} height={ICON_SIZE} />
                </div>
              </EmailShareButton>
              <LinkedinShareButton url={url} title={title}>
                <div
                  title="Share on Linkedin"
                  className="p-2 hover:bg-primary-500 text-primary-500 hover:text-white"
                >
                  <IconLinkedin width={ICON_SIZE} height={ICON_SIZE} />
                </div>
              </LinkedinShareButton>
              <div
                title="Copy link"
                className="p-2 hover:bg-primary-500 text-primary-500 hover:text-white"
                role="button"
                onClick={() => {
                  copyTextToClipboard(url);
                }}
              >
                <CopyIcon width={ICON_SIZE} height={ICON_SIZE} />
              </div>
            </div>
          </div>
        )}
      </div>
    </ClickAway>
  );
}
